import React from "react";
import "../Aboutus/Aboutus.css";
import AboutPost from "./About-post";
import profileImg from "../Aboutus/profile.webp"; // use your own image path
import bigImg from "../Aboutus/big.webp"; // large right image
import smallImg from "../Aboutus/rasta.webp"; // small overlapping image
import decoImg from "../Aboutus/flight.webp"; // left side bottom decoration image
import airBalloon from "../Aboutus/baloon.webp"; // right side top decoration
import Why from "../Why/Why";
import Connect from "../Connect/Connect";
import Team from "../Team/Team";
import { Link } from "react-router-dom";

const Aboutus = () => {
  return (
    <>
      <AboutPost />

      <section className="about-section">
        <div className="about-leftt">
          <span className="about-tag">✈️ GET TO KNOW US</span>
          <h1 className="about-heading">
            Experience the World <br /> with (Company Name)
          </h1>
          <p className="about-description">
            Discover new places with (Company Name), your trusted guide to
            exciting and memorable travel adventures across the globe.
          </p>

          <div className="consultation-box">
            <img
              src={profileImg}
              alt="Consultation"
              className="consultation-img"
            />
            <div className="consultation-text">
              <h3>Free Consultation</h3>
              <p>
                Talk with our experts to start planning your next great escape
                with ease and confidence.
              </p>
            </div>
          </div>

          <ul className="about-points">
            <li>✔️ Tailored trips for every kind of traveler</li>
            <li>✔️ Supportive and reliable travel advisors</li>
            <li>✔️ Trusted global travel specialists</li>
          </ul>
          <Link to="/contactus">
            <button className="explore-btn">Explore More</button>
          </Link>

          <div className="left-deco-img"></div>
        </div>

        <div className="about-rightt">
          <img src={bigImg} alt="Big Visual" className="big-image" />
          <img src={smallImg} alt="Small Visual" className="small-image" />
          <div className="image-bar">Beautiful Places</div>
          <div className="airballoon-deco"></div>
        </div>
      </section>

      <Why />
      <Connect />
      <Team />
    </>
  );
};

export default Aboutus;
